module.exports = __webpack_public_path__ + "img/default.24f9569c.svg";